import React, { PropTypes } from 'react';
import PromotionEditForm from '../PromotionEditForm';
import LoadingSpinner from '../../LoadingSpinner';

class PromotionEdit extends React.Component {
  static propTypes = {
    title: PropTypes.node.isRequired,
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.fetch(this.props.params.id);
  }

  render() {
    let { loading, title, rest } = this.props;

    return (
      <LoadingSpinner show={loading}>
        <PromotionEditForm label={title} {...rest}/>
      </LoadingSpinner>
    );
  }
}

export default PromotionEdit;




// WEBPACK FOOTER //
// ./src/components/Promotions/PromotionEdit/PromotionEdit.jsx